import React                from 'react';
import PropTypes            from 'prop-types';
import { observer, inject } from 'mobx-react';
import { OngletMenu       } from './OngletMenu';


/* *********************************************************************************** */
/* **********                                                               ********** */
/* **********                              Menu                             ********** */
/* **********                                                               ********** */
/* *********************************************************************************** */

export const Menu = inject(['store'])(observer(class Menu extends React.Component {

        /* ---------------------- */
        /* Affichage du composant */
        /* ---------------------- */

        render () {
            
            /* --------------------------------- */
            /* Formatage de la liste des onglets */
            /* --------------------------------- */

            const listeOnglet = this.props.menu.listeOnglet.filter((onglet => onglet.afficher)).map ( (onglet,i) => {
                
                return (
                    <OngletMenu
                        key      = {i}
                        onglet   = {onglet}
                        vertical = {this.props.menu.vertical}
                        action   = {this.props.store.actionMenu.bind(this.props.store)}
                    />
                )
            } );

            /* ------------------- */
            /* Renvoi du composant */
            /* ------------------- */

            return (

                <div style={this.props.styleMenu}>
                    { listeOnglet }
                </div>

            )

        }
  
    } // Fin de la classe Menu
))

/* ------------------------------------ */
/* Définition de la structure des props */
/* ------------------------------------ */

Menu.defaultProps = {
    styleMenu : null
}

Menu.propTypes = {
  styleMenu : PropTypes.object
}


// WEBPACK FOOTER //
// ./src/components/commun/Menu.js